export const isDebugEnabledSelector = (state) => state.getIn(['debug', 'enabled']);
export const isDebugToolbarEnabledSelector = (state) => state.getIn(['debug', 'toolbar']);

export const isDebugToolbarToolEnabled = (toolName) => (state) => !!state.getIn(['debug', 'enabledTools', toolName]);
